import {getAddresses} from "./actions/getAddresses";


export const actions = {
    getAddresses
};
